import { FC } from 'react';

import { Loader, VSpacing } from '@hh.ru/magritte-ui';

import { VacancyFiltersPanel } from 'components/CampaignCreationWizard/VacancySelectStep/components/VacancyListTab/VacancyFiltersPanel/VacancyFiltersPanel';
import { VacancyListTabEmptyState } from 'components/CampaignCreationWizard/VacancySelectStep/components/VacancyListTab/VacancyListTabEmptyState/VacancyListTabEmptyState';
import { WizardVacanciesTable } from 'components/CampaignCreationWizard/VacancySelectStep/components/VacancyListTab/WizardVacanciesTable/WizardVacanciesTable';

import {
    selectWizardSelectedFilterValues,
    selectWizardVacancies,
    selectWizardVacanciesIsLoading,
    selectWizardVacancySearchValue,
} from 'store/models/campaignCreationWizard';
import { useSelector } from 'store/utils';

import styles from 'components/CampaignCreationWizard/VacancySelectStep/components/VacancyListTab/VacancyListTab.module.less';

export const VacancyListTab: FC = () => {
    const vacancies = useSelector(selectWizardVacancies);
    const isLoading = useSelector(selectWizardVacanciesIsLoading);
    const vacancySearchValue = useSelector(selectWizardVacancySearchValue);
    const selectedFilterValues = useSelector(selectWizardSelectedFilterValues);

    const isFiltered =
        vacancySearchValue !== '' || selectedFilterValues.areas.length > 0 || selectedFilterValues.users.length > 0;

    if (!isLoading && vacancies.length === 0 && !isFiltered) {
        return <VacancyListTabEmptyState variant="noVacancies" />;
    }

    return (
        <>
            <VacancyFiltersPanel />
            {isLoading ? (
                <div className={styles.loaderWrapper}>
                    <Loader size={48} />
                </div>
            ) : (
                <>
                    <VSpacing default={24} s={16} xs={16} />
                    {vacancies.length === 0 ? (
                        <VacancyListTabEmptyState variant="noResults" />
                    ) : (
                        <WizardVacanciesTable />
                    )}
                </>
            )}
        </>
    );
};
